export type ApiErrorLike = {
  message?: string;
  errors?: Record<string, string[]>;
};

export function getApiErrorMessage(
  err: unknown,
  fallback = "Došlo je do greške. Pokušajte ponovno.",
): string {
  const apiError = err as ApiErrorLike;

  return (
    Object.values(apiError.errors ?? {})[0]?.[0] ??
    apiError.message ??
    fallback
  );
}

export function getApiFieldErrors(err: unknown): Record<string, string[]> {
  const apiError = err as ApiErrorLike;
  return apiError.errors ?? {};
}